import {ChangeDetectionStrategy, Component, input, InputSignal, OnInit} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {MatTooltip} from '@angular/material/tooltip';

import {DrawingModel} from 'shared/models';
import {ConfigService} from '../../../config.service';

@Component({
  selector: 'player-ui',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, MatCard, MatCardContent, MatCardHeader, MatCardTitle, MatTooltip],
  templateUrl: './player-ui.html',
  styleUrl: './player-ui.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayerUi implements OnInit {
  drawing: InputSignal<DrawingModel> = input.required<DrawingModel>();

  protected bucketUrl!: string;

  constructor(
    // @TODO
    // protected themeService: CustomizerSettingsService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.bucketUrl = this.configService.config.bucketUrl;
  }
}
